import isNil from './isNil';

const hasOwnProperty = Object.prototype.hasOwnProperty;

const has = (object, key) => {
    if (isNil(object)) {
        return false;
    }
    return hasOwnProperty.call(object, key);
};

export default has;
